var ReactRedux = require('react-redux');
var Reselect = require('reselect');

var settingActions = require('../../actions/settingActions');
var SettingsPresentational = require('../../components/Admin/Settings.jsx');

var { createSelector } = Reselect;

export function getSettings(state) {
	return state.settings;
};

export function getSettingList(state) {
	return getSettings(state).list;
};

var mapStateToProps = function(state) {
	return createSelector (
		getSettingList,
		(settings) => ({
			settings
		})
	);
};

var mapDispatchToProps = function(dispatch) {
	return {
		load: function() {
			dispatch(settingActions.loadSettings());
		},

		unload: function() {
			dispatch(settingActions.unsubscribe());
		},

		update: function(key, data) {
			dispatch(settingActions.updateSetting(key, data));
		}
	};
};

module.exports = ReactRedux.connect(
	mapStateToProps, mapDispatchToProps
)(SettingsPresentational);


// WEBPACK FOOTER //
// ./src/containers/Admin/Settings.js